import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insert-teacher-request',
  templateUrl: './insert-teacher-request.component.html',
  styleUrls: ['./insert-teacher-request.component.css']
})
export class InsertTeacherRequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
